import { useContext } from "react";
import { RightDrawerContext } from "../context/RightDrawerContext";
import CustomDrawer from "../common/CustomDrawer";

const RightDrawer = () => {
  const { open, content } = useContext(RightDrawerContext);
  return <CustomDrawer children={content} open={open} />;
};

export default RightDrawer;
